import { render, staticRenderFns } from "./AppLabel.vue?vue&type=template&id=ec1f8e54&scoped=true"
import script from "./AppLabel.vue?vue&type=script&lang=js"
export * from "./AppLabel.vue?vue&type=script&lang=js"
import style0 from "./AppLabel.vue?vue&type=style&index=0&id=ec1f8e54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec1f8e54",
  null
  
)

export default component.exports